<div class="material-datatables">
  <table
    id="selectScraps"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%"
  >
    <thead>
      <tr>
        <th class="disabled-sorting">
          <b>
            <a
              class="btn btn-link btn-primary btn-just-icon"
              (click)="selectAll()"
            >
              <i class="material-icons">{{
                checkAll() ? "check_box" : "check_box_outline_blank"
              }}</i>
            </a>
            <!-- ({{bulk.length}}) -->
          </b>
        </th> <!-- 1 -->
        <th><b> Id </b></th> <!-- 2 -->
        <th><b>Accumulation Start Date</b></th> <!-- 3 -->

        <th><b> Category </b></th> <!-- 4 -->
        <th><b> Tare Weight </b></th> <!-- 5 -->
        <th><b> Last update </b></th> <!-- 6 -->
        <th>
          <b> {{ status ? "Destination" : "Location" }} </b>
        </th> <!-- 7 -->
        <th *ngIf="status"><b> Status </b></th> <!-- 8 -->
        <th *ngIf="status" style="text-align: right;"> <b> Comments </b> </th> <!-- 9 -->
      </tr> 
    </thead>

    <tbody>
      <tr *ngFor="let item of data">
        <td>
          <a
            class="btn btn-link btn-info btn-just-icon"
            (click)="selectItem(item.id)"
          >
            <i class="material-icons">{{
              check(item.id) ? "check_box" : "check_box_outline_blank"
            }}</i>
          </a>
        </td><!-- 1 -->
        <td>{{ item.id }}</td><!-- 2 -->
        <td>{{ item.fechaCreado.timestamp * 1000 | date: "MM/dd/yyyy" }}</td><!-- 3 -->
        <td>{{ item.categoryId.name }}</td><!-- 4 -->
        <td>{{ item.tareWeight }}</td><!-- 5 -->
        <td>
          <span *ngIf="item.fechaModificado !== null">
            {{ item.fechaModificado.timestamp * 1000 | date: "MM/dd/yyyy" }}
          </span>
        </td><!-- 6 -->
        <td *ngIf="!status"><span >
          {{item.internalLocation !==  null ? item.internalLocation.locationName + ': ' + item.internalLocation.locationRow + ' - ' +
          item.internalLocation.locationBay + ' - ' + item.internalLocation.locationLevel + ' - ' + item.internalLocation.locationSection : ''}}
        </span></td>
        <td *ngIf="status">
          <span *ngIf="item.destination !== null">
                      {{item.destination}}

          </span>
        </td><!-- 7 -->
        <td *ngIf="status">
          <button
            class="btn btn-sm {{
              item.status === 'pending' ? 'btn-warning' : 'btn-info'
            }}"
          >
            {{ item.status }}
          </button>
        </td><!-- 8 -->
        <td *ngIf="status" style="text-align: right">
          <button class="btn btn-warning btn-sm" (click)="openComments(item)">
            Add
          </button>
        </td><!-- 9 -->
      </tr>
    </tbody>
  </table>
</div>
